import React, { lazy, Suspense } from "react";
import { commonData } from "data/CommonDataPoint";

const Login = lazy(() => import("@pages/Login"));
const BookingForm = lazy(() => import("pages/Print/BookingForm/index"));
const ConfirmationReceipt = lazy(
  () => import("pages/Print/ConfirmationReceipt"),
);

const LoginOtp = lazy(() => import("@pages/Login/LoginOtp"));
const ForgotPassword = lazy(() => import("@pages/Login/ForgotPassword"));
const RegisterUser = lazy(() => import("@pages/Login/RegisterUser"));
const RegisterSuccess = lazy(() => import("pages/Login/RegisterSuccess"));
const UserRequest = lazy(() => import("pages/SalesPerson/UserRequest"));
const UnlockAccount = lazy(() => import("@pages/Login/UnlockAccount"));
const ViewNotes = lazy(() => import("@pages/GRE/ViewNotes"));
const ResetPassword = lazy(() => import("@pages/Login/ResetPassword"));

//Super Admin

const SuperAdminProjectListing = lazy(
  () => import("@pages/SuperAdmin/ProjectListing"),
);
const SuperAdminProjectDetails = lazy(
  () => import("@pages/SuperAdmin/ProjectDetails"),
);
const SuperAdminEBW = lazy(() => import("@pages/SuperAdmin/EBW"));
const SuperAdminEBWConfirmation = lazy(
  () => import("@pages/SuperAdmin/EBWConfirmation"),
);
const SuperAdminVerifyBooking = lazy(
  () => import("@pages/SuperAdmin/VerifyBooking"),
);
const SuperAdminVerifyBookingOTP = lazy(
  () => import("@pages/SuperAdmin/VerifyBookingOTP"),
);
const SuperAdminVerificationSuccess = lazy(
  () => import("@pages/SuperAdmin/VerificationSuccess"),
);
const SuperAdminChooseApartment = lazy(
  () => import("@pages/SuperAdmin/ChooseApartment"),
);
const SuperAdminUserDashboard = lazy(
  () => import("@pages/SuperAdmin/UserDashboard"),
);
const SuperAdminUploadDocument = lazy(
  () => import("@pages/SuperAdmin/UploadDocument"),
);
const SuperAdminApartmentListing = lazy(
  () => import("@pages/SuperAdmin/ApartmentListing"),
);
const SuperAdminApartmentViewDetails = lazy(
  () => import("@pages/SuperAdmin/ApartmentViewDetails"),
);
const SuperAdminApartmentViewDetailsTwo = lazy(
  () => import("@pages/SuperAdmin/ApartmentViewDetailsTwo"),
);
const SuperAdminCustomerDetails = lazy(
  () => import("@pages/SuperAdmin/CustomerDetails"),
);
const SuperAdminChooseApartmentStep1 = lazy(
  () => import("@pages/SuperAdmin/ChooseApartmentStep1"),
);
const SuperAdminChooseApartmentStep3 = lazy(
  () => import("@pages/SuperAdmin/ChooseApartmentStep3"),
);
const SuperAdminMakePayment = lazy(
  () => import("@pages/SuperAdmin/MakePayment"),
);
const SuperAdminViewPayment = lazy(
  () => import("@pages/SuperAdmin/ViewPayment"),
);
const SuperAdminEbwApplicant = lazy(
  () => import("@pages/SuperAdmin/EbwApplicant"),
);
const SuperAdminPaymentSuccess = lazy(
  () => import("@components/SuperAdmin/MakePayment/PaymentSuccess"),
);
const SuperAdminCustomerSearch = lazy(
  () => import("@pages/SuperAdmin/CustomerSearch"),
);
const SuperAdminCustomerSearchTwo = lazy(
  () => import("@pages/SuperAdmin/CustomerSearchTwo"),
);
const SuperAdminCustomerSearchDetails = lazy(
  () => import("@pages/SuperAdmin/CustomerSearchDetails"),
);
const SuperAdminCustomerSearchConfirmation = lazy(
  () => import("@pages/SuperAdmin/CustomerSearchConfirmation"),
);
const SuperAdminAssignCustomer = lazy(
  () => import("@pages/SuperAdmin/AssignCustomer"),
);
const SuperAdminViewBookingDetails = lazy(
  () => import("@pages/SuperAdmin/ViewBookingDetails"),
);
const SuperAdminBooking = lazy(() => import("@pages/SuperAdmin/Booking"));
const SuperAdminEBWStep2 = lazy(() => import("@pages/SuperAdmin/EBWStep2"));
const SuperAdminPayments = lazy(() => import("@pages/SuperAdmin/Payments"));
const SuperAdminDashboard = lazy(() => import("pages/SuperAdmin/Dashboard"));
const SuperAdminChooseTowerMobileOne = lazy(
  () => import("pages/SuperAdmin/ChooseTowerMobileOne"),
);
const SuperAdminChooseTowerMobileTwo = lazy(
  () => import("@pages/SuperAdmin/ChooseTowerMobileTwo"),
);
const SuperAdminChooseTowerMobileThree = lazy(
  () => import("@pages/SuperAdmin/ChooseTowerMobileThree"),
);
const SuperAdminChooseTowerMobileFour = lazy(
  () => import("@pages/SuperAdmin/ChooseTowerMobileFour"),
);
const SuperAdminCustomerData = lazy(
  () => import("pages/SuperAdmin/CustomerData"),
);
const SuperAdminUserRequest = lazy(
  () => import("pages/SuperAdmin/UserRequest"),
);
const SuperAdminSMSandEmail = lazy(
  () => import("pages/SuperAdmin/SmsandEmail"),
);
const SuperAdminSMSandEmailGeneric = lazy(
  () => import("pages/SuperAdmin/SmsandEmailGeneric"),
);
const SuperAdminEmail = lazy(() => import("pages/SuperAdmin/Email"));
const SuperAdminSMS = lazy(() => import("@pages/SuperAdmin/SMS"));
const ProjectOtherDocuments = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectOtherDocument"),
);

const ProjectContents = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectContent"),
);
const ProjectCheckList = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectCheckList/"),
);
const ProjectAssets = lazy(
  () => import("@pages/SuperAdmin/Projects/ProjectAssets"),
);
const ProjectTypology = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectTypology"),
);
const ProjectPlotPhases = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectPlotPhases"),
);
const ProjectEbwTypology = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectEbwTypology"),
);
const ProjectHighlights = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectHighlights"),
);
const ProjectFeatures = lazy(
  () => import("@pages/SuperAdmin/Projects/ProjectFeatures"),
);
const AdjustmentRequests = lazy(() => import("pages/SuperAdmin/ViewDiscount"));
const AdjustmentRequestsDetails = lazy(
  () => import("pages/SuperAdmin/ViewDiscountDetails"),
);
const EBWPaymentList = lazy(() => import("pages/Common/EBW/EBWPaymentList"));
const EBWList = lazy(() => import("pages/SuperAdmin/EbwList"));
const SuperAdminPayment = lazy(
  () => import("pages/Common/PaginatedPaymentList"),
);
const BankList = lazy(() => import("pages/Common/BankList"));

//Customer

const CustomerProjectListing = lazy(
  () => import("pages/Customer/ProjectListing"),
);
const CustomerProjectDetails = lazy(
  () => import("pages/Customer/ProjectDetails"),
);
const CustomerEBW = lazy(() => import("pages/Customer/EBW"));
const CustomerEBWConfirmation = lazy(
  () => import("pages/Customer/EBWConfirmation"),
);
const CustomerUserDashboard = lazy(
  () => import("pages/Customer/UserDashboard"),
);
const CustomerVerifyBooking = lazy(
  () => import("@pages/Customer/VerifyBooking"),
);
const CustomerUploadDocument = lazy(
  () => import("@pages/Customer/UploadDocument"),
);
const CustomerVerifyBookingOTP = lazy(
  () => import("@pages/Customer/VerifyBookingOTP"),
);
const CustomerVerificationSuccess = lazy(
  () => import("@pages/Customer/VerificationSuccess"),
);
const CustomerEBWStep2 = lazy(() => import("pages/Customer/EBWStep2"));
const CustomerPayment = lazy(() => import("pages/Customer/Payments"));
const CustomerEbwList = lazy(() => import("pages/Customer/EbwList"));
const CustomerBookingList = lazy(() => import("@pages/Customer/BookingList"));
const CustomerDocumentList = lazy(() => import("pages/Customer/DocumentList"));
const CustomerUserProfile = lazy(() => import("@pages/Customer/UserProfile"));
const CustomerManageApplicant = lazy(
  () => import("pages/Customer/ManageApplicant"),
);
const CustomerVerifyBookingDetails = lazy(
  () => import("@pages/Customer/ViewBookingDetails"),
);

//GRE

const GRECustomerSearch = lazy(() => import("pages/GRE/CustomerSearch"));
const GRECustomerSearchTwo = lazy(() => import("@pages/GRE/CustomerSearchTwo"));
const GRECustomerSearchDetails = lazy(
  () => import("pages/GRE/CustomerSearchDetails"),
);
const GRECustomerSearchConfirmation = lazy(
  () => import("pages/GRE/CustomerSearchConfirmation"),
);
const GREAssignCustomer = lazy(() => import("@pages/GRE/AssignCustomer"));
const GREEmail = lazy(() => import("@pages/GRE/Email"));
const GRESMS = lazy(() => import("@pages/GRE/SMS"));
const GRECustomerData = lazy(() => import("pages/GRE/CustomerData"));
const GREViewNotes = lazy(() => import("pages/GRE/ViewNotes"));

//Sourcing Team Lead

const STLAssignCustomer = lazy(
  () => import("@pages/SourcingTeamLead/AssignCustomer"),
);

// Sales person

const SalesPersonLogin = lazy(() => import("pages/SalesPerson/Login"));
const SalesPersonLoginOtp = lazy(
  () => import("@pages/SalesPerson/Login/LoginOtp"),
);
const SalesPersonForgotPassword = lazy(
  () => import("@pages/SalesPerson/Login/ForgotPassword"),
);
const SalesPersonRegisterUser = lazy(
  () => import("@pages/SalesPerson/Login/RegisterUser"),
);
const SalesPersonRegisterSuccess = lazy(
  () => import("@pages/SalesPerson/Login/RegisterSuccess"),
);
const SalesPersonUnlockAccount = lazy(
  () => import("pages/SalesPerson/Login/UnlockAccount"),
);
const SalesPersonResetPassword = lazy(
  () => import("@pages/SalesPerson/Login/ResetPassword"),
);
const SalesPersonDashboard = lazy(() => import("pages/SalesPerson/Dashboard"));
const SalesPersonProjectListing = lazy(
  () => import("@pages/SalesPerson/ProjectListing"),
);
const SalesPersonProjectDetails = lazy(
  () => import("pages/SalesPerson/ProjectDetails"),
);
const SalesPersonBooking = lazy(() => import("pages/SalesPerson/Booking"));
const SalesPersonUserRequest = lazy(
  () => import("pages/SalesPerson/UserRequest"),
);
const SalesPersonApartmentListing = lazy(
  () => import("pages/Common/ApartmentListing"),
);
const SalesPersonApartmentViewDetails = lazy(
  () => import("pages/SalesPerson/ApartmentViewDetails"),
);
const SalesPersonPlotViewDetails = lazy(
  () => import("pages/SalesPerson/PlotViewDetails"),
);
const SalesPersonApartmentDummyViewDetails = lazy(
  () => import("pages/SalesPerson/ApartmentViewDetails/ViewDetails"),
);
const SalesPersonBookingViewDetail = lazy(
  () => import("pages/SalesPerson/BookingViewDetail"),
);
const SalesPersonPaymentScheduleDetails = lazy(
  () => import("pages/SalesPerson/PaymentScheduleDetails"),
);
const SalesPersonApartmentViewDetailsTwo = lazy(
  () => import("@pages/SalesPerson/ApartmentViewDetailsTwo"),
);
const SalesPersonCustomerDetails = lazy(
  () => import("pages/SalesPerson/CustomerDetails"),
);
const SalesPersonChooseApartmentStep1 = lazy(
  () => import("pages/SalesPerson/ChooseApartmentStep1"),
);
const SalesPersonPlotMapping = lazy(
  () => import("pages/SalesPerson/PlotMapping"),
);
const SalesPersonChooseApartmentStep3 = lazy(
  () => import("pages/SalesPerson/ChooseApartmentStep3"),
);
const SalesPersonChooseApartment = lazy(
  () => import("pages/SalesPerson/ChooseApartment"),
);
const SalesPersonMakePayment = lazy(
  () => import("pages/SalesPerson/MakePayment"),
);
const SalesPersonPaymentSuccess = lazy(
  () => import("@components/SalesPerson/MakePayment/PaymentSuccess"),
);
const SalesPersonUploadDocument = lazy(
  () => import("pages/SalesPerson/UploadDocument"),
);
const SalesPersonEbw = lazy(() => import("@pages/SalesPerson/EBW"));
const SalesPersonEbwStep2 = lazy(() => import("@pages/SalesPerson/EBWStep2"));
const SalesPersonEBWConfirmation = lazy(
  () => import("@pages/SalesPerson/EBWConfirmation"),
);
const SalesPersonPayments = lazy(() => import("pages/SalesPerson/Payments"));
const SalesPersonManageApplicant = lazy(
  () => import("pages/SalesPerson/ManageApplicant"),
);
const SalesPersonCustomerData = lazy(
  () => import("pages/SalesPerson/CustomerData"),
);
const ProjectForm = lazy(
  () => import("pages/SuperAdmin/Projects/Project/index"),
);
const SalesPersonVerifyBooking = lazy(
  () => import("pages/SalesPerson/VerifyBooking"),
);
const SalesPersonVerifyBookingOTP = lazy(
  () => import("pages/SalesPerson/VerifyBookingOTP"),
);
const SalesPersonVerificationSuccess = lazy(
  () => import("pages/SalesPerson/VerificationSuccess"),
);
const SalesPersonMailingAddress = lazy(
  () => import("pages/SalesPerson/MailingAddress"),
);
const Success = lazy(() => import("@pages/Common/Success/Success"));
const LoginSucess = lazy(() => import("pages/Common/Login/LoginSucess"));
const SpViewNotes = lazy(() => import("pages/SalesPerson/ViewNotes"));
const RejectReason = lazy(() => import("pages/Common/RejectReason"));
const ProjectManageTowers = lazy(
  () => import("pages/SuperAdmin/Projects/ProjectManageTowers"),
);
const GetQuotation = lazy(() => import("@pages/Print/GetQuotation"));

//Regional Head

const RegionalHeadDashboard = lazy(
  () => import("pages/RegionalHead/Dashboard"),
);
const RegionalHeadEbwList = lazy(() => import("pages/Common/PaginatedEBWList"));
const RegionalHeadBooking = lazy(
  () => import("pages/Common/PaginatedBookingList"),
);
const RegionalHeadPayment = lazy(
  () => import("pages/Common/PaginatedPaymentList"),
);
const RegionalHeadCustomerList = lazy(
  () => import("pages/Common/PaginatedCustomerList"),
);

//Project Head

const ProjectHeadDashboard = lazy(() => import("pages/ProjectHead/Dashboard"));
const ProjectHeadEbwList = lazy(() => import("pages/Common/PaginatedEBWList"));
const ProjectHeadBooking = lazy(
  () => import("pages/Common/PaginatedBookingList"),
);
const ProjectHeadPayment = lazy(
  () => import("pages/Common/PaginatedPaymentList"),
);
const ProjectHeadCustomerList = lazy(
  () => import("pages/Common/PaginatedCustomerList"),
);

//Vertical Head
const VerticalHead = lazy(() => import("pages/VerticalHead/Dashboard"));
//Vertical Head
const SubVerticalHead = lazy(() => import("pages/SubVerticalHead/Dashboard"));

//CRM User
const CrmDashboard = lazy(() => import("pages/CRM/Dashboard"));
const CrmBookingDetail = lazy(() => import("pages/CRM/BookingRequestDetails"));

//Error page

const ErrorPage = lazy(() => import("pages/Common/ErrorPage"));
const LogHistory = lazy(() => import("pages/Common/LogHistory"));
const PaymentReceipt = lazy(() => import("pages/Print/PaymentReceipt"));

const BookingCommentsHistory = lazy(() => import("pages/Common/CommentsList"));

const superAdminRoutes = [
  { path: `/${commonData?.admin}/banklist`, component: BankList },
  { path: `/${commonData?.admin}/ebwlist`, component: EBWList },
  { path: `/${commonData?.admin}/payments`, component: EBWPaymentList },
  { path: `/${commonData?.admin}/adjustments`, component: AdjustmentRequests },
  {
    path: `/${commonData?.admin}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.admin}/reject-reason`,
    component: RejectReason,
  },
  {
    path: `/${commonData?.admin}/adjustments-details`,
    component: AdjustmentRequestsDetails,
  },
  {
    path: `/${commonData?.admin}/manage-towers`,
    component: ProjectManageTowers,
  },
  { path: `/${commonData?.admin}/project-content`, component: ProjectContents },
  {
    path: `/${commonData?.admin}/project-checklist`,
    component: ProjectCheckList,
  },
  {
    path: `/${commonData?.admin}/project-typology`,
    component: ProjectTypology,
  },
  {
    path: `/${commonData?.admin}/project-plot-phases`,
    component: ProjectPlotPhases,
  },
  // { path: `/${commonData?.admin}/user-request`, component: UserRequest },
  {
    path: `/${commonData?.admin}/project-ebw-typology`,
    component: ProjectEbwTypology,
  },
  { path: `/${commonData?.admin}/project-assets`, component: ProjectAssets },
  {
    path: `/${commonData?.admin}/project-features`,
    component: ProjectFeatures,
  },
  {
    path: `/${commonData?.admin}/project-highlights`,
    component: ProjectHighlights,
  },
  { path: `/${commonData?.admin}/profile`, component: CustomerUserProfile },
  {
    path: `/${commonData?.admin}/project-listing`,
    component: CustomerProjectListing,
  },
  { path: `/${commonData?.admin}/add-project`, component: ProjectForm },
  { path: `/${commonData?.admin}/edit-project`, component: ProjectForm },
  {
    path: `/${commonData?.admin}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.admin}/ebw`, component: SuperAdminEBW },
  {
    path: `/${commonData?.admin}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  // {
  //   path: `/${commonData?.admin}/ebw-confirmation`,
  //   component: SuperAdminEBWConfirmation,
  // },
  { path: `/${commonData?.admin}/dashboard`, component: SuperAdminDashboard },
  // { path: `/${commonData?.admin}/verify-booking`, component: SuperAdminVerifyBooking },
  // { path: `/${commonData?.admin}/verify-booking-otp`, component: SuperAdminVerifyBookingOTP },
  // { path: `/${commonData?.admin}/verify-success`, component: SuperAdminVerificationSuccess },
  // { path: `/${commonData?.admin}/choose-apartment`, component: SuperAdminChooseApartment },
  // { path: `/${commonData?.admin}/choose-apartment`, component: SuperAdminChooseApartment },
  // {
  //   path: `/${commonData?.admin}/user-dashboard`,
  //   component: SuperAdminUserDashboard,
  // },
  // { path: `/${commonData?.admin}/upload-document`, component: SuperAdminUploadDocument },
  // { path: `/${commonData?.admin}/apartment-listing`, component: SuperAdminApartmentListing },
  {
    path: `/${commonData?.admin}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  // {
  //   path: `/${commonData?.admin}/apartment-view-details`,
  //   component: SuperAdminApartmentViewDetails,
  // },
  // {
  //   path: `/${commonData?.admin}/apartment-view-details-two`,
  //   component: SuperAdminApartmentViewDetailsTwo,
  // },
  // {
  //   path: `/${commonData?.admin}/customer-details`,
  //   component: SuperAdminCustomerDetails,
  // },
  // {
  //   path: `/${commonData?.admin}/choose-apartment-step1`,
  //   component: SuperAdminChooseApartmentStep1,
  // },
  {
    path: `/${commonData?.admin}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.admin}/plot-mapping`,
    component: SalesPersonPlotMapping,
  },
  // {
  //   path: `/${commonData?.admin}/choose-apartment-step3`,
  //   component: SuperAdminChooseApartmentStep3,
  // },
  // {
  //   path: `/${commonData?.admin}/make-payment`,
  //   component: SuperAdminMakePayment,
  // },
  // {
  //   path: `/${commonData?.admin}/view-payment`,
  //   component: SuperAdminViewPayment,
  // },
  // {
  //   path: `/${commonData?.admin}/ebw-applicant`,
  //   component: SuperAdminEbwApplicant,
  // },
  // {
  //   path: `/${commonData?.admin}/payment-success`,
  //   component: SuperAdminPaymentSuccess,
  // },
  // { path: `/${commonData?.admin}/customer-search`, component: SuperAdminCustomerSearch },
  // {
  //   path: `/${commonData?.admin}/customer-search-two`,
  //   component: SuperAdminCustomerSearchTwo,
  // },
  // {
  //   path: `/${commonData?.admin}/customer-search-details`,
  //   component: SuperAdminCustomerSearchDetails,
  // },
  // {
  //   path: `/${commonData?.admin}/customer-search-confirmation`,
  //   component: SuperAdminCustomerSearchConfirmation,
  {
    path: `/${commonData?.admin}/customer-search`,
    component: GRECustomerSearch,
  },
  {
    path: `/${commonData?.admin}/customer-search-two`,
    component: GRECustomerSearchTwo,
  },
  {
    path: `/${commonData?.admin}/customer-search-details`,
    component: GRECustomerSearchDetails,
  },
  {
    path: `/${commonData?.admin}/customer-search-confirmation`,
    component: GRECustomerSearchConfirmation,
  },
  {
    path: `/${commonData?.admin}/customers`,
    component: GRECustomerData,
  },
  { path: `/${commonData?.admin}/ebw-list`, component: CustomerEbwList },
  {
    path: `/${commonData?.admin}/assign-customer`,
    component: STLAssignCustomer,
  },
  // },
  // {
  //   path: `/${commonData?.admin}/assign-customer`,
  //   component: SuperAdminAssignCustomer,
  // },
  // {
  //   path: `/${commonData?.admin}/choose-tower-mobile-one`,
  //   component: SuperAdminChooseTowerMobileOne,
  // },
  // {
  //   path: `/${commonData?.admin}/choose-tower-mobile-two`,
  //   component: SuperAdminChooseTowerMobileTwo,
  // },
  // {
  //   path: `/${commonData?.admin}/choose-tower-mobile-three`,
  //   component: SuperAdminChooseTowerMobileThree,
  // },
  // {
  //   path: `/${commonData?.admin}/choose-tower-mobile-four`,
  //   component: SuperAdminChooseTowerMobileFour,
  // },
  // {
  //   path: `/${commonData?.admin}/ebw-step2`,
  //   component: SuperAdminEBWStep2,
  // },
  {
    path: `/${commonData?.admin}/customer`,
    component: SuperAdminCustomerData,
  },
  {
    path: `/${commonData?.admin}/user`,
    component: SuperAdminCustomerData,
  },
  {
    path: `/${commonData?.admin}/booking`,
    component: SalesPersonBooking,
  },
  // {
  //   path: `/${commonData?.admin}/payment`,
  //   component: SuperAdminPayments,
  // },
  {
    path: `/${commonData?.admin}/user-request`,
    component: SuperAdminUserRequest,
  },
  {
    path: `/${commonData?.admin}/sms-email`,
    component: SuperAdminSMSandEmail,
  },
  {
    path: `/${commonData?.admin}/sms-email-generic`,
    component: SuperAdminSMSandEmailGeneric,
  },

  {
    path: `/${commonData?.admin}/request-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.admin}/swapped-request-details`,
    component: SalesPersonBookingViewDetail,
  },

  { path: `/${commonData?.admin}/email`, component: SuperAdminEmail },
  { path: `/${commonData?.admin}/sms`, component: SuperAdminSMS },
  // {
  //   path: `/${commonData?.admin}/booking-details`,
  //   component: SuperAdminViewBookingDetails,
  // },
  {
    path: `/${commonData?.admin}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.admin}/plot-view-details`,
    component: SalesPersonPlotViewDetails,
  },
  {
    path: `/${commonData?.admin}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.admin}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.admin}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.admin}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  { path: `/${commonData?.admin}/payment-list`, component: CustomerPayment },
  {
    path: `/${commonData?.admin}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.admin}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.admin}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  // {
  //   path: `/${commonData?.admin}/choose-apartment-step1`,
  //   component: SalesPersonChooseApartmentStep1,
  // },
  {
    path: `/${commonData?.admin}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.admin}/logs`,
    component: LogHistory,
  },
  {
    path: `/${commonData?.admin}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.admin}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.admin}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.admin}/upload-document`,
    component: SalesPersonUploadDocument,
  },

  // {
  //   path: `/${commonData?.admin}/booking`,
  //   component: SalesPersonBooking,
  // },
  // {
  //   path: `/${commonData?.admin}/user-request`,
  //   component: SalesPersonUserRequest,
  // },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.admin}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.admin}/payment-receipt`,
    component: PaymentReceipt,
  },
  { path: `/${commonData?.admin}/get-quotation`, component: GetQuotation },

  {
    path: `/${commonData?.admin}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.admin}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.admin}/ebw`, component: SalesPersonEbw },
  { path: `/${commonData?.admin}/ebw-step2`, component: CustomerEBWStep2 },
  // { path: `/${commonData?.admin}/ebw-step2`, component: SalesPersonEbwStep2 },
  {
    path: `/${commonData?.admin}/ebw-confirmation`,
    component: SalesPersonEBWConfirmation,
  },
  {
    path: `/${commonData?.admin}/ebw-lists`,
    component: SalesPersonManageApplicant,
  },
  // { path: `/${commonData?.admin}/payment`, component: SalesPersonPayments },
  { path: `/${commonData?.admin}/payment`, component: SuperAdminPayment },
  {
    path: `/${commonData?.admin}/customer`,
    component: SalesPersonCustomerData,
  },
  { path: `/${commonData?.admin}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.admin}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.admin}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.admin}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.admin}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.admin}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.admin}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.admin}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.admin}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.admin}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.admin}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.admin}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.admin}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.admin}/other-documents`,
    component: ProjectOtherDocuments,
  },

  {
    path: `/${commonData?.admin}/booking-comments-history`,
    component: BookingCommentsHistory,
  },

  { path: `*`, component: ErrorPage },
];

const customerRoutes = [
  {
    path: `/${commonData?.customerRole}/ebwPayments`,
    component: EBWPaymentList,
  },
  // { path: `/:type`, component: CustomerProjectListing },
  {
    path: `/${commonData?.customerRole}/project-listing`,
    component: CustomerProjectListing,
  },
  {
    path: `/${commonData?.customerRole}/project-details`,
    component: CustomerProjectDetails,
  },
  { path: `/${commonData?.customerRole}/ebw`, component: CustomerEBW },
  {
    path: `/${commonData?.customerRole}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  {
    path: `/${commonData?.customerRole}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  {
    path: `/${commonData?.customerRole}/user-dashboard`,
    component: CustomerUserDashboard,
  },
  // {
  //   path: `/${commonData?.customerRole}/verify-booking`,
  //   component: CustomerVerifyBooking,
  // },
  // {
  //   path: `/${commonData?.customerRole}/upload-document`,
  //   component: CustomerUploadDocument,
  // },
  {
    path: `/${commonData?.customerRole}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.customerRole}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.customerRole}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.customerRole}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.customerRole}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.customerRole}/booking-form`,
    component: BookingForm,
  },
  // {
  //   path: `/${commonData?.customerRole}/verify-booking-otp`,
  //   component: CustomerVerifyBookingOTP,
  // },
  // {
  //   path: `/${commonData?.customerRole}/verify-success`,
  //   component: CustomerVerificationSuccess,
  // },
  { path: `/${commonData?.customerRole}/payment`, component: CustomerPayment },
  { path: `/${commonData?.customerRole}/ebw-list`, component: CustomerEbwList },
  {
    path: `/${commonData?.customerRole}/bookings`,
    component: CustomerBookingList,
  },
  {
    path: `/${commonData?.customerRole}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.customerRole}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.customerRole}/profile`,
    component: CustomerUserProfile,
  },
  // {
  //   path: `/${commonData?.customerRole}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.customerRole}/booking-details`,
    component: CustomerVerifyBookingDetails,
  },
  {
    path: `/${commonData?.customerRole}/payment-receipt`,
    component: PaymentReceipt,
  },
  { path: `*`, component: ErrorPage },
];

const greUserRoutes = [
  {
    path: `/${commonData?.greRole}/customer-search`,
    component: GRECustomerSearch,
  },
  {
    path: `/${commonData?.greRole}/customer-search-two`,
    component: GRECustomerSearchTwo,
  },
  {
    path: `/${commonData?.greRole}/customer-search-details`,
    component: GRECustomerSearchDetails,
  },
  {
    path: `/${commonData?.greRole}/customer-search-confirmation`,
    component: GRECustomerSearchConfirmation,
  },
  {
    path: `/${commonData?.greRole}/customers`,
    component: GRECustomerData,
  },
  {
    path: `/${commonData?.greRole}/view-notes`,
    component: GREViewNotes,
  },

  { path: `*`, component: ErrorPage },
];

const closingTeamLeadRoutes = [
  {
    path: `/${commonData?.closingTeamLeadRole}/dashboard`,
    component: ProjectHeadDashboard,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/payment-receipt`,
    component: PaymentReceipt,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/assign-customer`,
    component: STLAssignCustomer,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/payment`,
    component: ProjectHeadPayment,
  },
  // {
  //   path: `/${commonData?.closingTeamLeadRole}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.closingTeamLeadRole}/booking-applicants`,
    component: CustomerManageApplicant,
  },

  {
    path: `/${commonData?.closingTeamLeadRole}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/booking-form`,
    component: BookingForm,
  },

  {
    path: `/${commonData?.closingTeamLeadRole}/ebw-lists`,
    component: ProjectHeadEbwList,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/payments`,
    component: EBWPaymentList,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/customer`,
    component: ProjectHeadCustomerList,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/plot-view-details`,
    component: SalesPersonPlotViewDetails,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/project-details`,
    component: CustomerProjectDetails,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `/${commonData?.closingTeamLeadRole}/ebw`, component: CustomerEBW },
  {
    path: `/${commonData?.closingTeamLeadRole}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.closingTeamLeadRole}/user-request`,
    component: SuperAdminUserRequest,
  },
  { path: `*`, component: ErrorPage },

  // {
  //   path: `/:type/customer`,
  //   component: GRECustomerData,
  // },
];

const salesPersonRoutes = [
  // { path: `/:type`, component: SalesPersonDashboard },
  {
    path: `/${commonData?.salesRole}/dashboard`,
    component: SalesPersonDashboard,
  },
  {
    path: `/${commonData?.salesRole}/payment-receipt`,
    component: PaymentReceipt,
  },
  {
    path: `/${commonData?.salesRole}/customer-search`,
    component: GRECustomerSearch,
  },
  {
    path: `/${commonData?.salesRole}/customer-search-two`,
    component: GRECustomerSearchTwo,
  },
  {
    path: `/${commonData?.salesRole}/customer-search-details`,
    component: GRECustomerSearchDetails,
  },
  {
    path: `/${commonData?.salesRole}/customer-search-confirmation`,
    component: GRECustomerSearchConfirmation,
  },
  { path: `/${commonData?.salesRole}/login`, component: SalesPersonLogin },
  { path: `/${commonData?.salesRole}/payments`, component: EBWPaymentList },
  {
    path: `/${commonData?.salesRole}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.salesRole}/plot-mapping`,
    component: SalesPersonPlotMapping,
  },
  {
    path: `/${commonData?.salesRole}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.salesRole}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.salesRole}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.salesRole}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.salesRole}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.salesRole}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.salesRole}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.salesRole}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  { path: `/${commonData?.salesRole}/ebw-list`, component: CustomerEbwList },
  {
    path: `/${commonData?.salesRole}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.salesRole}/reject-reason`,
    component: RejectReason,
  },
  {
    path: `/${commonData?.salesRole}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.salesRole}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.salesRole}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.salesRole}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.salesRole}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.salesRole}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.salesRole}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.salesRole}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.salesRole}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.salesRole}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.salesRole}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.salesRole}/logs`,
    component: LogHistory,
  },
  {
    path: `/${commonData?.salesRole}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.salesRole}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.salesRole}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.salesRole}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.salesRole}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },

  {
    path: `/${commonData?.salesRole}/booking`,
    component: SalesPersonBooking,
  },
  // {
  //   path: `/${commonData?.salesRole}/user-request`,
  //   component: SalesPersonUserRequest,
  // },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.salesRole}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  { path: `/${commonData?.salesRole}/get-quotation`, component: GetQuotation },

  {
    path: `/${commonData?.salesRole}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.salesRole}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.salesRole}/ebw`, component: SalesPersonEbw },
  { path: `/${commonData?.salesRole}/ebw-step2`, component: CustomerEBWStep2 },
  // { path: `/${commonData?.salesRole}/ebw-step2`, component: SalesPersonEbwStep2 },
  // {
  //   path: `/${commonData?.salesRole}/ebw-confirmation`,
  //   component: SalesPersonEBWConfirmation,
  // },
  {
    path: `/${commonData?.salesRole}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  {
    path: `/${commonData?.salesRole}/ebw-lists`,
    component: SalesPersonManageApplicant,
  },
  { path: `/${commonData?.salesRole}/payment`, component: SalesPersonPayments },
  {
    path: `/${commonData?.salesRole}/customer`,
    component: SalesPersonCustomerData,
  },
  { path: `/${commonData?.salesRole}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.salesRole}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.salesRole}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.salesRole}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.salesRole}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.salesRole}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.salesRole}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.salesRole}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.salesRole}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.salesRole}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.salesRole}/booking-applicants`,
    component: CustomerManageApplicant,
  },

  {
    path: `/${commonData?.salesRole}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.salesRole}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `*`, component: ErrorPage },
];

const sourcingTeamLeadRoutes = [
  {
    path: `/${commonData?.sourcingTeamLeadRole}/dashboard`,
    component: ProjectHeadDashboard,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/payment-receipt`,
    component: PaymentReceipt,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/assign-customer`,
    component: STLAssignCustomer,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/payment`,
    component: ProjectHeadPayment,
  },
  // {
  //   path: `/${commonData?.sourcingTeamLeadRole}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/booking-form`,
    component: BookingForm,
  },

  {
    path: `/${commonData?.sourcingTeamLeadRole}/ebw-lists`,
    component: ProjectHeadEbwList,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/payments`,
    component: EBWPaymentList,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/customer`,
    component: ProjectHeadCustomerList,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/project-details`,
    component: CustomerProjectDetails,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `/${commonData?.sourcingTeamLeadRole}/ebw`, component: CustomerEBW },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.sourcingTeamLeadRole}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  { path: `*`, component: ErrorPage },

  // {
  //   path: `/:type/customer`,
  //   component: GRECustomerData,
  // },
];

const sourcingManagerRoutes = [
  // { path: `/:type`, component: SalesPersonDashboard },
  {
    path: `/${commonData?.sourcingManagerRole}/dashboard`,
    component: SalesPersonDashboard,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/login`,
    component: SalesPersonLogin,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/payments`,
    component: EBWPaymentList,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.sourcingManagerRole}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.sourcingManagerRole}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/ebw-list`,
    component: CustomerEbwList,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/reject-reason`,
    component: RejectReason,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/logs`,
    component: LogHistory,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },

  {
    path: `/${commonData?.sourcingManagerRole}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  // {
  //   path: `/${commonData?.sourcingManagerRole}/user-request`,
  //   component: SalesPersonUserRequest,
  // },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.sourcingManagerRole}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/get-quotation`,
    component: GetQuotation,
  },

  {
    path: `/${commonData?.sourcingManagerRole}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.sourcingManagerRole}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.sourcingManagerRole}/ebw`, component: SalesPersonEbw },
  {
    path: `/${commonData?.sourcingManagerRole}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  // { path: `/${commonData?.sourcingManagerRole}/ebw-step2`, component: SalesPersonEbwStep2 },
  // {
  //   path: `/${commonData?.sourcingManagerRole}/ebw-confirmation`,
  //   component: SalesPersonEBWConfirmation,
  // },
  {
    path: `/${commonData?.sourcingManagerRole}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/ebw-lists`,
    component: SalesPersonManageApplicant,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/payment`,
    component: SalesPersonPayments,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/customer`,
    component: SalesPersonCustomerData,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/booking-form`,
    component: BookingForm,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.sourcingManagerRole}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.sourcingManagerRole}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.sourcingManagerRole}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `*`, component: ErrorPage },
];

const regionalHeadRoutes = [
  {
    path: `/${commonData?.regionalHead}/dashboard`,
    component: RegionalHeadDashboard,
  },
  {
    path: `/${commonData?.regionalHead}/payment-receipt`,
    component: PaymentReceipt,
  },
  { path: `/${commonData?.regionalHead}/login`, component: SalesPersonLogin },
  {
    path: `/${commonData?.regionalHead}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.regionalHead}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.regionalHead}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.regionalHead}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.regionalHead}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.regionalHead}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.regionalHead}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.regionalHead}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.regionalHead}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.regionalHead}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.regionalHead}/reject-reason`,
    component: RejectReason,
  },
  { path: `/${commonData?.regionalHead}/payments`, component: EBWPaymentList },

  {
    path: `/${commonData?.regionalHead}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.regionalHead}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  // {
  //   path: `/${commonData?.regionalHead}/apartmentviewDummy-details`,
  //   component: SalesPersonApartmentDummyViewDetails,
  // },
  {
    path: `/${commonData?.regionalHead}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.regionalHead}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.regionalHead}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.regionalHead}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.regionalHead}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.regionalHead}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.regionalHead}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.regionalHead}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.regionalHead}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.regionalHead}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.regionalHead}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.regionalHead}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.regionalHead}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.regionalHead}/upload-document`,
    component: SalesPersonUploadDocument,
  },

  // {
  //   path: `/${commonData?.regionalHead}/booking`,
  //   component: RegionalHeadBooking,
  // },
  {
    path: `/${commonData?.regionalHead}/logs`,
    component: LogHistory,
  },
  {
    path: `/${commonData?.regionalHead}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.regionalHead}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.regionalHead}/user-request`,
    component: SuperAdminUserRequest,
  },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.regionalHead}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.regionalHead}/get-quotation`,
    component: GetQuotation,
  },

  {
    path: `/${commonData?.regionalHead}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.regionalHead}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.regionalHead}/ebw`, component: SalesPersonEbw },
  {
    path: `/${commonData?.regionalHead}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  // { path: `/${commonData?.regionalHead}/ebw-step2`, component: SalesPersonEbwStep2 },
  // {
  //   path: `/${commonData?.regionalHead}/ebw-confirmation`,
  //   component: SalesPersonEBWConfirmation,
  // },
  {
    path: `/${commonData?.regionalHead}/ebw-lists`,
    component: RegionalHeadEbwList,
  },
  {
    path: `/${commonData?.regionalHead}/payment`,
    component: RegionalHeadPayment,
  },
  {
    path: `/${commonData?.regionalHead}/customer`,
    component: RegionalHeadCustomerList,
  },
  // { path: `/${commonData?.regionalHead}/customer`, component: SalesPersonCustomerData },
  { path: `/${commonData?.regionalHead}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.regionalHead}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.regionalHead}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.regionalHead}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.regionalHead}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.regionalHead}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.regionalHead}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.regionalHead}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.regionalHead}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.regionalHead}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.regionalHead}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.regionalHead}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.regionalHead}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  { path: `*`, component: ErrorPage },
];
const projectHeadRoutes = [
  {
    path: `/${commonData?.projectHead}/dashboard`,
    component: ProjectHeadDashboard,
  },
  {
    path: `/${commonData?.projectHead}/payment-receipt`,
    component: PaymentReceipt,
  },
  { path: `/${commonData?.projectHead}/login`, component: SalesPersonLogin },
  {
    path: `/${commonData?.projectHead}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.projectHead}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.projectHead}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.projectHead}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.projectHead}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.projectHead}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.projectHead}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.projectHead}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.projectHead}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.projectHead}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.projectHead}/reject-reason`,
    component: RejectReason,
  },
  { path: `/${commonData?.projectHead}/payments`, component: EBWPaymentList },

  {
    path: `/${commonData?.projectHead}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  // { path: `/${commonData?.projectHead}/choose-apartment`, component: SalesPersonChooseApartment },

  {
    path: `/${commonData?.projectHead}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  // {
  //   path: `/${commonData?.projectHead}/apartmentviewDummy-details`,
  //   component: SalesPersonApartmentDummyViewDetails,
  // },
  {
    path: `/${commonData?.projectHead}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.projectHead}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.projectHead}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.projectHead}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.projectHead}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.projectHead}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.projectHead}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.projectHead}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.projectHead}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.projectHead}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.projectHead}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.projectHead}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.projectHead}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.projectHead}/upload-document`,
    component: SalesPersonUploadDocument,
  },

  // {
  //   path: `/${commonData?.projectHead}/booking`,
  //   component: ProjectHeadBooking,
  // },
  {
    path: `/${commonData?.projectHead}/logs`,
    component: LogHistory,
  },
  {
    path: `/${commonData?.projectHead}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.projectHead}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.projectHead}/user-request`,
    component: SalesPersonUserRequest,
  },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.projectHead}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.projectHead}/get-quotation`,
    component: GetQuotation,
  },

  {
    path: `/${commonData?.projectHead}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.projectHead}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.projectHead}/ebw`, component: SalesPersonEbw },
  {
    path: `/${commonData?.projectHead}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  // { path: `/${commonData?.projectHead}/ebw-step2`, component: SalesPersonEbwStep2 },
  // {
  //   path: `/${commonData?.projectHead}/ebw-confirmation`,
  //   component: SalesPersonEBWConfirmation,
  // },
  {
    path: `/${commonData?.projectHead}/ebw-lists`,
    component: ProjectHeadEbwList,
  },
  {
    path: `/${commonData?.projectHead}/payment`,
    component: ProjectHeadPayment,
  },
  {
    path: `/${commonData?.projectHead}/customer`,
    component: ProjectHeadCustomerList,
  },
  // { path: `/${commonData?.projectHead}/customer`, component: SalesPersonCustomerData },
  { path: `/${commonData?.projectHead}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.projectHead}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.projectHead}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.projectHead}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.projectHead}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.projectHead}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.projectHead}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.projectHead}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.projectHead}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.projectHead}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.projectHead}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.projectHead}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.projectHead}/ebw-confirmation`,
    component: CustomerEBWConfirmation,
  },
  { path: `*`, component: ErrorPage },
];
const verticalHeadRoutes = [
  { path: `/${commonData?.verticalHead}/dashboard`, component: VerticalHead },
  {
    path: `/${commonData?.verticalHead}/payment-receipt`,
    component: PaymentReceipt,
  },
  { path: `/${commonData?.verticalHead}/login`, component: SalesPersonLogin },
  {
    path: `/${commonData?.verticalHead}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.verticalHead}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.verticalHead}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.verticalHead}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.verticalHead}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.verticalHead}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.verticalHead}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.verticalHead}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.verticalHead}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.verticalHead}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.verticalHead}/reject-reason`,
    component: RejectReason,
  },
  {
    path: `/${commonData?.verticalHead}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.verticalHead}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  // {
  //   path: `/${commonData?.verticalHead}/apartmentviewDummy-details`,
  //   component: SalesPersonApartmentDummyViewDetails,
  // },
  {
    path: `/${commonData?.verticalHead}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.verticalHead}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.verticalHead}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.verticalHead}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.verticalHead}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.verticalHead}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.verticalHead}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.verticalHead}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.verticalHead}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.verticalHead}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.verticalHead}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.verticalHead}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.verticalHead}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.verticalHead}/upload-document`,
    component: SalesPersonUploadDocument,
  },

  {
    path: `/${commonData?.verticalHead}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.verticalHead}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.verticalHead}/logs`,
    component: LogHistory,
  },
  // {
  //   path: `/${commonData?.verticalHead}/booking`,
  //   component: ProjectHeadBooking,
  // },
  {
    path: `/${commonData?.verticalHead}/user-request`,
    component: SalesPersonUserRequest,
  },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.verticalHead}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.verticalHead}/get-quotation`,
    component: GetQuotation,
  },

  {
    path: `/${commonData?.verticalHead}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.verticalHead}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.verticalHead}/ebw`, component: SalesPersonEbw },
  {
    path: `/${commonData?.verticalHead}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  // { path: `/${commonData?.verticalHead}/ebw-step2`, component: SalesPersonEbwStep2 },
  {
    path: `/${commonData?.verticalHead}/ebw-confirmation`,
    component: SalesPersonEBWConfirmation,
  },
  {
    path: `/${commonData?.verticalHead}/ebw-lists`,
    component: SalesPersonManageApplicant,
  },
  {
    path: `/${commonData?.verticalHead}/payment`,
    component: SalesPersonPayments,
  },
  {
    path: `/${commonData?.verticalHead}/customer`,
    component: SalesPersonCustomerData,
  },
  { path: `/${commonData?.verticalHead}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.verticalHead}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.verticalHead}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.verticalHead}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.verticalHead}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.verticalHead}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.verticalHead}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.verticalHead}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.verticalHead}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.verticalHead}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.verticalHead}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.verticalHead}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `*`, component: ErrorPage },
];
const subVerticalHeadRoutes = [
  {
    path: `/${commonData?.subVerticalHead}/dashboard`,
    component: SubVerticalHead,
  },
  {
    path: `/${commonData?.subVerticalHead}/payment-receipt`,
    component: PaymentReceipt,
  },
  {
    path: `/${commonData?.subVerticalHead}/login`,
    component: SalesPersonLogin,
  },
  {
    path: `/${commonData?.subVerticalHead}/login-otp`,
    component: SalesPersonLoginOtp,
  },
  {
    path: `/${commonData?.subVerticalHead}/forgot-password`,
    component: SalesPersonForgotPassword,
  },
  {
    path: `/${commonData?.subVerticalHead}/sign-up`,
    component: SalesPersonRegisterUser,
  },
  {
    path: `/${commonData?.subVerticalHead}/register-success`,
    component: SalesPersonRegisterSuccess,
  },
  {
    path: `/${commonData?.subVerticalHead}/unlock-account`,
    component: SalesPersonUnlockAccount,
  },
  {
    path: `/${commonData?.subVerticalHead}/project-listing`,
    component: SalesPersonProjectListing,
  },
  {
    path: `/${commonData?.subVerticalHead}/project-details`,
    component: CustomerProjectDetails,
  },
  // { path: `/${commonData?.subVerticalHead}/project-details`, component: SalesPersonProjectDetails },
  {
    path: `/${commonData?.subVerticalHead}/apartment-listing`,
    component: SalesPersonApartmentListing,
  },
  {
    path: `/${commonData?.subVerticalHead}/view-notes`,
    component: SpViewNotes,
  },
  {
    path: `/${commonData?.subVerticalHead}/reject-reason`,
    component: RejectReason,
  },
  {
    path: `/${commonData?.subVerticalHead}/apartment-view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  {
    path: `/${commonData?.subVerticalHead}/view-details`,
    component: SalesPersonApartmentViewDetails,
  },
  // {
  //   path: `/${commonData?.subVerticalHead}/apartmentviewDummy-details`,
  //   component: SalesPersonApartmentDummyViewDetails,
  // },
  {
    path: `/${commonData?.subVerticalHead}/apartmentview-details`,
    component: SalesPersonApartmentDummyViewDetails,
  },
  {
    path: `/${commonData?.subVerticalHead}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  {
    path: `/${commonData?.subVerticalHead}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.subVerticalHead}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.subVerticalHead}/payment-list`,
    component: CustomerPayment,
  },
  {
    path: `/${commonData?.subVerticalHead}/apartment-view-details-two`,
    component: SalesPersonApartmentViewDetailsTwo,
  },
  {
    path: `/${commonData?.subVerticalHead}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-apartment`,
    component: SalesPersonChooseApartment,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-apartment-step1`,
    component: SalesPersonChooseApartmentStep1,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-apartment-step3`,
    component: SalesPersonChooseApartmentStep3,
  },
  {
    path: `/${commonData?.subVerticalHead}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.subVerticalHead}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.subVerticalHead}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.subVerticalHead}/upload-document`,
    component: SalesPersonUploadDocument,
  },

  {
    path: `/${commonData?.subVerticalHead}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.subVerticalHead}/booking-comments-history`,
    component: BookingCommentsHistory,
  },
  {
    path: `/${commonData?.subVerticalHead}/logs`,
    component: LogHistory,
  },
  // {
  //   path: `/${commonData?.subVerticalHead}/booking`,
  //   component: ProjectHeadBooking,
  // },
  {
    path: `/${commonData?.subVerticalHead}/user-request`,
    component: SalesPersonUserRequest,
  },
  // { path: `/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.subVerticalHead}/confirmation-receipt`,
    component: ConfirmationReceipt,
  },
  {
    path: `/${commonData?.subVerticalHead}/get-quotation`,
    component: GetQuotation,
  },

  {
    path: `/${commonData?.subVerticalHead}/reset-password`,
    component: SalesPersonResetPassword,
  },
  { path: `/${commonData?.subVerticalHead}/ebw`, component: CustomerEBW },
  // { path: `/${commonData?.subVerticalHead}/ebw`, component: SalesPersonEbw },
  {
    path: `/${commonData?.subVerticalHead}/ebw-step2`,
    component: CustomerEBWStep2,
  },
  // { path: `/${commonData?.subVerticalHead}/ebw-step2`, component: SalesPersonEbwStep2 },
  {
    path: `/${commonData?.subVerticalHead}/ebw-confirmation`,
    component: SalesPersonEBWConfirmation,
  },
  {
    path: `/${commonData?.subVerticalHead}/ebw-lists`,
    component: SalesPersonManageApplicant,
  },
  {
    path: `/${commonData?.subVerticalHead}/payment`,
    component: SalesPersonPayments,
  },
  {
    path: `/${commonData?.subVerticalHead}/customer`,
    component: SalesPersonCustomerData,
  },
  {
    path: `/${commonData?.subVerticalHead}/booking-form`,
    component: BookingForm,
  },
  {
    path: `/${commonData?.subVerticalHead}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.subVerticalHead}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.subVerticalHead}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.subVerticalHead}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-tower-mobile-one`,
    component: SuperAdminChooseTowerMobileOne,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-tower-mobile-two`,
    component: SuperAdminChooseTowerMobileTwo,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-tower-mobile-three`,
    component: SuperAdminChooseTowerMobileThree,
  },
  {
    path: `/${commonData?.subVerticalHead}/choose-tower-mobile-four`,
    component: SuperAdminChooseTowerMobileFour,
  },
  // {
  //   path: `/${commonData?.subVerticalHead}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.subVerticalHead}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.subVerticalHead}/document-list`,
    component: CustomerDocumentList,
  },
  { path: `*`, component: ErrorPage },
];
const crmUserRoutes = [
  { path: `/${commonData?.CRM}/dashboard`, component: CrmDashboard },
  { path: `/${commonData?.CRM}/booking-detail`, component: CrmBookingDetail },
  {
    path: `/${commonData?.CRM}/customer-details`,
    component: SalesPersonCustomerDetails,
  },
  {
    path: `/${commonData?.CRM}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.CRM}/booking-form`,
    component: BookingForm,
  },
  {
    path: `/${commonData?.CRM}/booking`,
    component: SalesPersonBooking,
  },
  {
    path: `/${commonData?.CRM}/booking-comments-history`,
    component: BookingCommentsHistory,
  },

  {
    path: `/${commonData?.CRM}/make-payment`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.CRM}/cost-sheet`,
    component: SalesPersonMakePayment,
  },
  {
    path: `/${commonData?.CRM}/payment-schedule`,
    component: SalesPersonPaymentScheduleDetails,
  },
  {
    path: `/${commonData?.CRM}/payment-success`,
    component: SalesPersonPaymentSuccess,
  },
  {
    path: `/${commonData?.CRM}/upload-document`,
    component: SalesPersonUploadDocument,
  },
  {
    path: `/${commonData?.CRM}/upload-booking-documents`,
    component: SalesPersonUploadDocument,
  },
  { path: `/${commonData?.CRM}/booking-form`, component: BookingForm },
  {
    path: `/${commonData?.CRM}/verify-booking`,
    component: SalesPersonVerifyBooking,
  },
  {
    path: `/${commonData?.CRM}/verify-booking-otp`,
    component: SalesPersonVerifyBookingOTP,
  },
  {
    path: `/${commonData?.CRM}/verify-success`,
    component: SalesPersonVerificationSuccess,
  },
  {
    path: `/${commonData?.CRM}/mailing-address`,
    component: SalesPersonMailingAddress,
  },
  // {
  //   path: `/${commonData?.CRM}/manage-applicants`,
  //   component: CustomerManageApplicant,
  // },
  {
    path: `/${commonData?.CRM}/booking-applicants`,
    component: CustomerManageApplicant,
  },
  {
    path: `/${commonData?.CRM}/document-list`,
    component: CustomerDocumentList,
  },
  {
    path: `/${commonData?.CRM}/bookingview-details`,
    component: SalesPersonBookingViewDetail,
  },
  { path: `/${commonData?.CRM}/payments`, component: EBWPaymentList },
  {
    path: `/${commonData?.CRM}/logs`,
    component: LogHistory,
  },
  { path: `*`, component: ErrorPage },

  // { path: `/:type/login`, component: SalesPersonLogin },
  // { path: `/:type/login-otp`, component: SalesPersonLoginOtp },
  // { path: `/:type/forgot-password`, component: SalesPersonForgotPassword },
  // { path: `/:type/sign-up`, component: SalesPersonRegisterUser },
  // { path: `/:type/register-success`, component: SalesPersonRegisterSuccess },
  // { path: `/:type/unlock-account`, component: SalesPersonUnlockAccount },
  // { path: `/:type/project-listing`, component: SalesPersonProjectListing },
  // { path: `/:type/project-details`, component: CustomerProjectDetails },
  // // { path: `/:type/project-details`, component: SalesPersonProjectDetails },
  // { path: `/:type/apartment-listing`, component: SalesPersonApartmentListing },
  // {
  //   path: `/:type/view-notes`,
  //   component: SpViewNotes,
  // },
  // {
  //   path: `/:type/apartment-view-details`,
  //   component: SalesPersonApartmentViewDetails,
  // },
  // {
  //   path: `/:type/view-details`,
  //   component: SalesPersonApartmentViewDetails,
  // },
  // // {
  // //   path: `/:type/apartmentviewDummy-details`,
  // //   component: SalesPersonApartmentDummyViewDetails,
  // // },
  // {
  //   path: `/:type/bookingview-details`,
  //   component: SalesPersonBookingViewDetail,
  // },
  // {
  //   path: `/:type/payment-schedule`,
  //   component: SalesPersonPaymentScheduleDetails,
  // },
  // { path: `/:type/payment-list`, component: CustomerPayment },
  // {
  //   path: `/:type/apartment-view-details-two`,
  //   component: SalesPersonApartmentViewDetailsTwo,
  // },
  // { path: `/:type/customer-details`, component: SalesPersonCustomerDetails },
  // { path: `/:type/choose-apartment`, component: SalesPersonChooseApartment },
  // {
  //   path: `/:type/choose-apartment-step1`,
  //   component: SalesPersonChooseApartmentStep1,
  // },
  // {
  //   path: `/:type/choose-apartment-step3`,
  //   component: SalesPersonChooseApartmentStep3,
  // },
  // { path: `/:type/make-payment`, component: SalesPersonMakePayment },
  // { path: `/:type/cost-sheet`, component: SalesPersonMakePayment },
  // { path: `/:type/payment-success`, component: SalesPersonPaymentSuccess },
  // { path: `/:type/upload-document`, component: SalesPersonUploadDocument },

  // {
  //   path: `/:type/booking`,
  //   component: ProjectHeadBooking,
  // },
  // {
  //   path: `/:type/user-request`,
  //   component: SalesPersonUserRequest,
  // },
  // // { path: `/booking-form`, component: BookingForm },
  // { path: `/:type/confirmation-receipt`, component: ConfirmationReceipt },
  // { path: `/:type/get-quotation`, component: GetQuotation },

  // { path: `/:type/reset-password`, component: SalesPersonResetPassword },
  // { path: `/:type/ebw`, component: CustomerEBW },
  // // { path: `/:type/ebw`, component: SalesPersonEbw },
  // { path: `/:type/ebw-step2`, component: CustomerEBWStep2 },
  // // { path: `/:type/ebw-step2`, component: SalesPersonEbwStep2 },
  // { path: `/:type/ebw-confirmation`, component: SalesPersonEBWConfirmation },
  // { path: `/:type/ebw-lists`, component: SalesPersonManageApplicant },
  // { path: `/:type/payment`, component: SalesPersonPayments },
  // { path: `/:type/customer`, component: SalesPersonCustomerData },
  // { path: `/:type/booking-form`, component: BookingForm },
  // { path: `/:type/verify-booking`, component: SalesPersonVerifyBooking },
  // { path: `/:type/verify-booking-otp`, component: SalesPersonVerifyBookingOTP },
  // { path: `/:type/verify-success`, component: SalesPersonVerificationSuccess },
  // { path: `/:type/mailing-address`, component: SalesPersonMailingAddress },
  // {
  //   path: `/:type/choose-tower-mobile-one`,
  //   component: SuperAdminChooseTowerMobileOne,
  // },
  // {
  //   path: `/:type/choose-tower-mobile-two`,
  //   component: SuperAdminChooseTowerMobileTwo,
  // },
  // {
  //   path: `/:type/choose-tower-mobile-three`,
  //   component: SuperAdminChooseTowerMobileThree,
  // },
  // {
  //   path: `/:type/choose-tower-mobile-four`,
  //   component: SuperAdminChooseTowerMobileFour,
  // },
  // { path: `/:type/manage-applicants`, component: CustomerManageApplicant },
  // { path: `/:type/document-list`, component: CustomerDocumentList },
];

const publicRoutes = [
  { path: `/login`, component: Login },
  { path: `/login-otp`, component: LoginOtp },
  { path: `/forgot-password`, component: ForgotPassword },
  { path: `/sign-up`, component: RegisterUser },
  { path: `/register-success`, component: RegisterSuccess },
  { path: `/unlock-account`, component: UnlockAccount },
  { path: `/booking-form`, component: BookingForm },
  { path: `/confirmation-receipt`, component: ConfirmationReceipt },
  { path: `/reset-password`, component: ResetPassword },
  { path: `/payment-success`, component: Success },
  { path: `/sso/callback`, component: LoginSucess },
];

export {
  // globalUserRoutes,
  superAdminRoutes,
  customerRoutes,
  greUserRoutes,
  closingTeamLeadRoutes,
  salesPersonRoutes,
  regionalHeadRoutes,
  projectHeadRoutes,
  publicRoutes,
  verticalHeadRoutes,
  subVerticalHeadRoutes,
  crmUserRoutes,
  sourcingTeamLeadRoutes,
  sourcingManagerRoutes,
};
